export default __webpack_public_path__ + "static/media/navigate_nextchevron_right.66e370e5.svg";